<template>
  <div class="eye-exam-card">
    <h3 class="eye-exam-card-title">
      <template v-if="date">{{ date | date('datetime') }}</template>
      <template v-if="date && title"> - </template>
      <template v-if="title">{{ title }}</template>
    </h3>

    <div class="eye-exam-card-table" v-if="computedRows.length > 0">
      <table class="table table-striped table-hover">
        <thead>
        <tr>
          <th v-for="(column, idx) in computedHeaders" :key="idx">{{ column.label }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(row, rIdx) in computedRows" :key="rIdx">
          <td>{{ row.label }}</td>
          <td v-for="(input) in row.inputs" :key="input.name">
            {{ input.display || '-' }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <slot />
    <st-data-display label="Laudo">
      <div class="text-pre d-flex">
        <strong class="text-gray mr-1">D:</strong>
        <span v-html="sanitizeHTML(inputs.reportR || '-')"></span>
      </div>
      <div class="text-pre d-flex">
        <strong class="text-gray mr-1">E:</strong>
        <span v-html="sanitizeHTML(inputs.reportL || '-')"></span>
      </div>
    </st-data-display>

    <st-data-display label="Observações" :value="inputs.observations" />

    <st-entity-file-manager
      :entity-id="patientId"
      :origin-id="recordId"
      :origin-child-id="examId"
      origin-type="medical_record_exam"
      :readonly="true"
      :show-empty-state="false"
      :key="examId"
    />

    <div class="mt-2">
      <button
        v-if="showEditButton"
        type="button"
        class="btn btn-info-outline btn-icon btn-icon-left mr-2"
        @click="$emit('edit')"
      >
        <fa-icon :icon="['fal', 'edit']" /> Editar
      </button>
      <st-button-report
        v-if="printUrl"
        type="pdf"
        :options="[]"
        :route="printUrl"
        button-class="btn-info"
      />
    </div>
  </div>
</template>

<script>
import { sanitize as sanitizeHTML } from '@/helpers/html';

export default {
  name: 'EyeExamCard',
  props: {
    title: {
      type: String,
      required: false,
    },
    date: {
      type: String,
      required: false,
    },
    patientId: {
      type: String,
      required: true,
    },
    recordId: {
      type: String,
      required: false,
    },
    examId: {
      type: String,
      required: false,
    },
    inputs: {
      type: Object,
      required: true,
    },
    headers: {
      type: Array,
      default: () => [],
    },
    rowsDefinition: {
      type: Array,
      default: () => [],
    },
    showEditButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sanitizeHTML,
    };
  },
  computed: {
    computedHeaders() {
      return this.headers.length > 0
        ? this.headers
        : [
          { label: '#' },
          { label: 'Olho Direito' },
          { label: 'Olho Esquerdo' },
        ];
    },
    computedRows() {
      return this.rowsDefinition.map(({ label, formatter, ...valuesBySide }) => {
        const inputs = ['R', 'L'].map((side) => {
          const keys = Array.isArray(valuesBySide[side])
            ? valuesBySide[side]
            : [valuesBySide[side]];
          const values = keys.map(k => this.inputs[k]);
          return {
            name: keys[0],
            display: formatter(...values),
          };
        });

        return { label, inputs };
      });
    },
    hasReport() {
      return this.inputs.reportR || this.inputs.reportL;
    },
    printUrl() {
      if (!this.recordId || !this.examId) return '';
      return `/medical-records/${this.recordId}/exams/${this.examId}/print`;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";

.eye-exam-card {
  border: $border-width solid $gray-color-light;
  border-radius: $border-radius;
  padding: $layout-spacing $layout-spacing;

  .eye-exam-card-title {
    font-size: $font-size;
    font-weight: 600;
    margin-bottom: $layout-spacing;
  }

  .eye-exam-card-table {
    border: $border-width solid $dark-blue-color-300;
    border-radius: $border-radius;
    margin-bottom: $layout-spacing;
    thead th:first-child {
      width: 34%;
    }
    tbody tr:first-child {
      td:first-child {
        border-top-left-radius: $border-radius;
      }
      td:last-child {
        border-top-right-radius: $border-radius;
      }
    }
    tbody tr:last-child {
      td {
        border-bottom: none;
      }
      td:first-child {
        border-bottom-left-radius: $border-radius;
      }
      td:last-child {
        border-bottom-right-radius: $border-radius;
      }
    }
  }

  .entity-files-manager {
    margin-bottom: $layout-spacing;
    .tile-file {
      background-color: $bg-color;
      border: $border-width solid $dark-blue-color-300;
    }
  }
}
</style>
